import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { EstablecimientosService } from 'src/app/main/pages/services/establecimientos.service';

@Component({
  selector: 'app-seleccionar-establecimiento',
  templateUrl: 'seleccionar-establecimiento.component.html',
  styleUrls: ['./seleccionar-establecimiento.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatTableModule, CommonModule],
})
export class SeleccionEstablecimientoComponent implements OnInit {
  displayedColumnsMatrices: string[] = [
    'establecimiento',
    'tipo',
    'nombreComercial',
    'ubicacion',
  ];
  displayedColumnsFiliales: string[] = [
    'establecimiento',
    'tipo',
    'nombreComercial',
    'ubicacion',
  ];
  displayedColumnsUnidadesNegocios: string[] = [
    'establecimiento',
    'tipo',
    'nombreComercial',
    'ubicacion',
  ];
  displayedColumnsSucursales: string[] = [
    'establecimiento',
    'tipo',
    'nombreComercial',
    'ubicacion',
  ];
  displayedColumnsAgencias: string[] = [
    'establecimiento',
    'tipo',
    'nombreComercial',
    'ubicacion',
  ];

  establecimientosMatrices!: any[];
  establecimientosFiliales!: any[];
  establecimientosUnidadesNegocios!: any[];
  establecimientosSucursales!: any[];
  establecimientosAgencias!: any[];

  constructor(
    private _dialogRef: MatDialogRef<SeleccionEstablecimientoComponent>,
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _establecimientosService: EstablecimientosService,
    private _sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.load();
  }

  load(): void {
    this._establecimientosService.getEstablecimientosPorTipo().subscribe(
      response => {
        const establecimientosTipos = response.body;
        this.establecimientosMatrices = establecimientosTipos.matrices;
        this.establecimientosFiliales = establecimientosTipos.filiales;
        this.establecimientosUnidadesNegocios =
          establecimientosTipos.unidadesNegocios;
        this.establecimientosSucursales = establecimientosTipos.sucursales;
        this.establecimientosAgencias = establecimientosTipos.agencias;
      },
      err => {
        console.error(err);
      },
    );
  }

  onNoClick(): void {
    this._dialogRef.close({ res: false });
  }

  seleccionar(item: any): void {
    this._dialogRef.close({ res: true, data: item });
  }

  sanitizeImagenMatriz(): any {
    if (
      this.establecimientosMatrices &&
      this.establecimientosMatrices.length > 0
    ) {
      const imagen = this.establecimientosMatrices[0].establecimientosImagen;
      if (imagen) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(
          'data:' + imagen.imagenContentType + ';base64, ' + imagen.imagen,
        );
      } else {
        return './assets/images/default-avatar.png';
      }
    } else {
      return './assets/images/default-avatar.png';
    }
  }

  sanitizeImagenFiliales(): any {
    if (
      this.establecimientosFiliales &&
      this.establecimientosFiliales.length > 0
    ) {
      const imagen =
        this.establecimientosFiliales[0].padre.establecimientosImagen;
      if (imagen) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(
          'data:' + imagen.imagenContentType + ';base64, ' + imagen.imagen,
        );
      } else {
        return './assets/images/default-avatar.png';
      }
    } else {
      return './assets/images/default-avatar.png';
    }
  }

  sanitizeImagenUnidadesNegocios(): any {
    if (
      this.establecimientosUnidadesNegocios &&
      this.establecimientosUnidadesNegocios.length > 0
    ) {
      const imagen =
        this.establecimientosUnidadesNegocios[0].padre.establecimientosImagen;
      if (imagen) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(
          'data:' + imagen.imagenContentType + ';base64, ' + imagen.imagen,
        );
      } else {
        return './assets/images/default-avatar.png';
      }
    } else {
      return './assets/images/default-avatar.png';
    }
  }

  sanitizeImagenSucursales(): any {
    if (
      this.establecimientosSucursales &&
      this.establecimientosSucursales.length > 0
    ) {
      const imagen =
        this.establecimientosSucursales[0].padre.establecimientosImagen;
      if (imagen) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(
          'data:' + imagen.imagenContentType + ';base64, ' + imagen.imagen,
        );
      } else {
        return './assets/images/default-avatar.png';
      }
    } else {
      return './assets/images/default-avatar.png';
    }
  }

  sanitizeImagenAgencias(): any {
    if (
      this.establecimientosAgencias &&
      this.establecimientosAgencias.length > 0
    ) {
      const imagen = this.establecimientosAgencias[0].establecimientosImagen;
      if (imagen) {
        return this._sanitizer.bypassSecurityTrustResourceUrl(
          'data:' + imagen.imagenContentType + ';base64, ' + imagen.imagen,
        );
      } else {
        return './assets/images/default-avatar.png';
      }
    } else {
      return './assets/images/default-avatar.png';
    }
  }
}
